import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"
import {vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {returnType as findBestMatchAlongSegmentReturnType} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/find-best-match-along-segment/definition"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const definition = {
    validation: {
        returns: z.union([
            z.object({
                nextPosition: vector2Like,
                details: findBestMatchAlongSegmentReturnType,
            }),
            z.undefined(),
        ]),
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            sourceCastRayOrigin: vector2Like,
            sourceCastRayTarget: vector2Like,
            currentCastRayOrigin: vector2Like,
            currentCastRayTarget: vector2Like,
            idealDistance: z.optional(z.number()), // default: distance between sourceCastRayOrigin and sourceCastRayTarget
            searchWidth: z.optional(z.number()), // default: idealDistance * 1.2
            searchOffset: z.optional(z.number()), // default: idealDistance * 0.4
        }),
    },
}
